import { useTheme } from "../context/ThemeContext";
import { Briefcase, UserCheck } from "lucide-react";
const Work = () => {
  const { isDarkMode } = useTheme();

  const getBoxClass = () => {
    const bgColor = isDarkMode ? 'bg-[#83329A]' : 'bg-[#A988D8]';
    return `${bgColor} p-6 rounded-lg w-full text-left shadow-lg flex justify-between items-center transition-all duration-300 ease-in-out hover:${bgColor} hover:scale-105`;
  };

  return (
    <section 
      className={`text-center py-10 ${
        isDarkMode ? 'bg-primary text-white' : 'bg-gray-200 text-gray-800'
      } transition-colors duration-300`} 
      id="about"
    >
      <h2 className="text-3xl font-bold mb-3" style={{ color: "#83329A" }}>
        About
      </h2>
      <p className={`mt-2 mb-8 text-lg ${
        isDarkMode ? 'text-tertiary' : 'text-gray-600'
      } transition-colors duration-300`}>
        Here are my internship and work experience
      </p>
      <div className="px-6 md:px-16 lg:px-24 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-6">
          <div className="w-full md:w-1/2 flex flex-col">
            <div className="flex items-center mb-3 justify-center md:justify-start">
              <UserCheck size={24} style={{ color: "#83329A", marginRight: "0.5rem" }} />
              <h3 className="text-2xl font-bold" style={{ color: "#83329A" }}>
                Internship
              </h3>
            </div>
            
            <div className={getBoxClass()}>
              <div>
                <h3 className="text-2xl font-bold" style={{ color: isDarkMode ? "#A988D8" : "#83329A" }}>
                  Dec 2024 - Mar 2025
                </h3>
                <h3 className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                  Web Developer Intern
                </h3>
                <p className={`font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                  Boom Technologies Inc.
                </p>
                <p className={`${isDarkMode ? 'text-white' : 'text-gray-700'} mt-2 text-sm`}>
                  SQ Film Laboratories Building, 17 Celia St.,
                  <br />
                  Brgy. Plainview, Mandaluyong City, Philippines
                </p>
              </div>
              <a 
                href="https://www.linkedin.com/company/boomtechco/posts/?feedView=all" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <img src="/assets/Boomtechlogo.png" alt="Boom Technologies Logo" className="w-24 h-22 rounded-md" />
              </a>
            </div>
          </div>

          <div className="w-full md:w-1/2 flex flex-col">
            <div className="flex items-center mb-3 justify-center md:justify-start">
              <Briefcase size={24} style={{ color: "#83329A", marginRight: "0.5rem" }} />
              <h3 className="text-2xl font-bold" style={{ color: "#83329A" }}>
                Work Experience
              </h3>
            </div>
            
            <div className={getBoxClass()}>
              <div>
                <h3 className="text-2xl font-bold" style={{ color: isDarkMode ? "#A988D8" : "#83329A" }}>
                  Jun 2025 - Present
                </h3>
                <h3 className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                  Software Engineer
                </h3>
                <p className={`font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                  Samsung R&D Institute Philippines
                </p>
                <p className={`${isDarkMode ? 'text-white' : 'text-gray-700'} mt-2 text-sm`}>
                  Science Hub Tower 3, McKinley Hill Cyberpark,
                  <br />
                  Pinagsama, Taguig City, Philippines.
                </p>
              </div>
              <a 
                href="https://www.linkedin.com/company/samsung-electronics-seao/posts/?feedView=all"
                target="_blank" 
                rel="noopener noreferrer"
              >
                <img src="/assets/samsung.jpg" alt="Samsung R&D Institute Logo" className="w-24 h-22 rounded-md" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Work;